const mockUrl = 'https://mock.corp.kuaishou.com/mock/1163';
const isDebugBundle = __DEV__ && process.env.NODE_ENV === 'production';
const isAllUseMock = process.env.MOCK === '1' || isDebugBundle; // 在keep上打debug包， 默认启用mock
export async function request(config, next) {
    if (!config.baseURL && (isAllUseMock || (config.mock && __DEV__))) {
        config.baseURL = mockUrl;
    }
    await next();
}
